import $ from "jquery";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default class NumberedTiles {
  $el = $("section.numbered-tiles");

  constructor() {
    if (!this.$el.length) return;

    // Register Plugin.
    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    //this.animateTiles();
  }

  animateTiles() {
    // Get the ID of this.$el.
    const id = this.$el.attr("id");

    gsap.from(`#${id} .tile`, {
      scrollTrigger: {
        trigger: `#${id}`,
        start: "top 80%",
        end: "bottom 80%",
        toggleActions: "play none none none",
        scrub: 1,
      },
      y: 50,
      opacity: 0,
      stagger: 0.1,
    });
  }
}
